import React, { Component } from 'react';

import { find, isFunction, keyBy, sortBy } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Button, Tag, Flex } from 'antd';
import { getScoreColor } from 'utils/ranking';
import Weight from 'components/controls/Weight';
import { useStakeholderController } from 'hooks/useStakeholderController';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { getItemAlteredByScenario } from 'utils/rules';
import UIContext from 'components/Utils/UIContext';
export const RisksTab = (props: any) => {
	const { t } = useTranslation();
	const uiContext = React.useContext(UIContext);

	const { createRiskImpact, updateRiskImpactStrength, deleteRiskImpact } = useStakeholderController();

	// Filtrer les risques par enabled !== false après application du scénario
	const filteredRisks = (props.risks || [])
		.map((r: any) => getItemAlteredByScenario(r, props.scenario))
		.filter((r: any) => r.enabled !== false);

	const indexedRisks = keyBy((props.risks || []), 'id');
	const isImpactingRisk = (riskId: string) => {
		if (
			indexedRisks[riskId] &&
			props.selection?.impactedRisks
				?.map((ii: any) => ii && ii.riskId)
				.includes(riskId)
		)
			return true;
		return false;
	};

	const getImpactingRiskDetails = (riskId: string) => {
		return find(
			props.selection?.impactedRisks || [],
			(ii: any) => ii && ii.riskId == riskId
		);
	};

	return (
		<>
			<Flex vertical className="mt-2">

				<Flex className="text-left mb-05">
					<strong>{t('models.item.fields.risks.name')}</strong>

					{isFunction(props.setPreferences) && <Button shape="circle" className="mini ml-auto" onDoubleClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
					}} onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						props.setPreferences(
							'pages',
							'navigator.risks',
							!props.areRisksVisible
						);
					}}>
						<FontAwesomeIcon
							icon={!props.areRisksVisible ? faChevronDown : faChevronUp}
						></FontAwesomeIcon>
					</Button>}

				</Flex>
			{props.areRisksVisible && <div className="text-left">
				{filteredRisks && filteredRisks.length ? (
				sortBy(filteredRisks || [], 'name').filter(r => !r.isOpportunity).map((i: any) => {
						const impactedRisk = getImpactingRiskDetails(
							i.id
						);

						return (
							<Tag.CheckableTag
								key={i.id}
								checked={isImpactingRisk(i.id)}
								onClick={async () => {
									if (!uiContext.canEdit) return;
									if (
											!impactedRisk ||
											!impactedRisk.id
										) {
											let createdImpact =
												await createRiskImpact(
													props.selection?.id,
													i.id
												);

											props.select({
												...props.selection,
												impactedRisks: [
													...(props.selection
														.impactedRisks ||
														[]),
													createdImpact
												]
											});
										} else if (
											impactedRisk.strength < 3
										) {
											updateRiskImpactStrength(
												impactedRisk,
												impactedRisk.strength + 1
											);

											props.select({
												...props.selection,
												impactedRisks:
													props.selection.impactedRisks.map(
														(r) => ({
															...r,
															strength:
																r.id ==
																	impactedRisk.id
																	? r.strength +
																	1
																	: r.strength
														})
													)
											});
										} else {
											deleteRiskImpact(
												impactedRisk.id,
												props.selection?.id,
											);

											props.select({
												...props.selection,
												impactedRisks:
													props.selection.impactedRisks.filter(
														(r) =>
															r.riskId !=
															impactedRisk.riskId
													)
											});
										}
									}}
									className={[
										'ImpactedRisk tag'
									].join(' ')}
								>
									<div
										className={'Trend v' + i.trend}
										style={
											i.trend == '50'
												? {}
												: {
													background:
														getScoreColor(
															i.trend
														)
												}
										}
									></div>
									<span className="tag__label" title={i.name}>{i.name}</span>

									{impactedRisk ? (
										<Weight onClick={() => { }}>
											{impactedRisk.strength}
										</Weight>
									) : null}
								</Tag.CheckableTag>
							);
						})
					) : (
						<div
							className="text-center"
							style={{ color: 'var(--ant-color-text-tertiary)' }}
						>
							{t('models.risk.messages.no_x')}
						</div>
					)}
				</div>}

				<Flex className="text-left mb-05 mt-2">
					<strong>{t('models.item.fields.opportunities.name')}</strong>

					{isFunction(props.setPreferences) && <Button shape="circle" className="mini ml-auto" onDoubleClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
					}} onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						props.setPreferences(
							'pages',
							'navigator.opportunities',
							!props.areOpportunitiesVisible
						);
					}}>
						<FontAwesomeIcon
							icon={!props.areOpportunitiesVisible ? faChevronDown : faChevronUp}
						></FontAwesomeIcon>
					</Button>}
				</Flex>
			{props.areOpportunitiesVisible && <div className="text-left">
				{filteredRisks && filteredRisks.length ? (
				sortBy(filteredRisks || [], 'name').filter(r => r.isOpportunity).map((i: any) => {
						const impactedRisk = getImpactingRiskDetails(
							i.id
						);

						return (
							<Tag.CheckableTag
								key={i.id}
								checked={isImpactingRisk(i.id)}
								onClick={async () => {
									if (!uiContext.canEdit) return;
									if (
											!impactedRisk ||
											!impactedRisk.id
										) {
											let createdImpact =
												await createRiskImpact(
													props.selection?.id,
													i.id
												);

											props.select({
												...props.selection,
												impactedRisks: [
													...(props.selection
														.impactedRisks ||
														[]),
													createdImpact
												]
											});
										} else if (
											impactedRisk.strength < 3
										) {
											updateRiskImpactStrength(
												impactedRisk,
												impactedRisk.strength + 1
											);

											props.select({
												...props.selection,
												impactedRisks:
													props.selection.impactedRisks.map(
														(r) => ({
															...r,
															strength:
																r.id ==
																	impactedRisk.id
																	? r.strength +
																	1
																	: r.strength
														})
													)
											});
										} else {
											deleteRiskImpact(
												impactedRisk.id,
												props.selection?.id,
											);

											props.select({
												...props.selection,
												impactedRisks:
													props.selection.impactedRisks.filter(
														(r) =>
															r.riskId !=
															impactedRisk.riskId
													)
											});
										}
									}}
									className={[
										'ImpactedRisk tag'
									].join(' ')}
								>
									<div
										className={'Trend v' + i.trend}
										style={
											i.trend == '50'
												? {}
												: {
													background:
														getScoreColor(
															i.trend
														)
												}
										}
									></div>
									<span className="tag__label" title={i.name}>{i.name}</span>

									{impactedRisk ? (
										<Weight onClick={() => { }}>
											{impactedRisk.strength}
										</Weight>
									) : null}
								</Tag.CheckableTag>
							);
						})
					) : (
						<div
							className="text-center"
							style={{ color: 'var(--ant-color-text-tertiary)' }}
						>
							{t('models.risk.messages.no_x')}
						</div>
					)}
				</div>}

			</Flex>
		</>
	);
};

export default RisksTab;
